<template>
  <div class="profile page">

    <div class="sidebar col-2">
      <router-link
        tag="md-button"
        :to="{ name: 'profile-albums' }">
        albums
      </router-link>

      <router-link
        tag="md-button"
        :to="{ name: 'profile-tags' }">
        tags
      </router-link>

      <router-link
        tag="md-button"
        :to="{ name: 'profile-settings' }">
        settings
      </router-link>
    </div>

    <div class="main col-10">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'ProfilePage'
  }
</script>
<style lang="scss" scoped>
  .profile.page {
    display: flex;
    .sidebar {
      display: flex;
      flex-direction: column;
      border-right: 1px solid $color-body;

      a {
        @include button_base;
        margin: 5px 0;
      }
    }

    .main {
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/profile/Profile.vue